import React, { useState, useEffect } from 'react';
import leftArrowIcon from './assets/left-scroll.png';
import rightArrowIcon from './assets/right-scroll.png';
import { Box, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';

const LimitedNextBestNavigator = ({ isDoc1, nextBest, currentId }) => {
  const [adjustedNextBest, setAdjustedNextBest] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    let list = [...nextBest];
    if (!list.includes(currentId)) {
      list.unshift(currentId);
    }
    setAdjustedNextBest(list);
    setCurrentIndex(list.findIndex(id => id === currentId));
  }, [nextBest, currentId]);

  // Don't render arrows if doc1 or not enough items
  if (isDoc1 || adjustedNextBest.length <= 1) return null;

  const arrowStyle = (disabled) => ({
    width: 40,
    height: 'auto',
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? 'default' : 'pointer',
    pointerEvents: disabled ? 'none' : 'auto',
    position: 'fixed',
    zIndex: 9999,
    marginTop: '60px',
  });

  const handleArrowClick = () => {
    setShowModal(true);
    setTimeout(() => setShowModal(false), 4000);
  };

  return (
    <>
      <img
        src={leftArrowIcon}
        alt="Previous"
        style={{ ...arrowStyle(currentIndex === 0), left: -22 }}
        onClick={handleArrowClick}
      />
      <img
        src={rightArrowIcon}
        alt="Next"
        style={{ ...arrowStyle(currentIndex === adjustedNextBest.length - 1), right: -22 }}
        onClick={handleArrowClick}
      />

      {showModal && (
        <Box
          sx={{
            position: 'fixed',
            top: '39%',
            left: '69%',
            transform: 'translate(-100%, -50%) scale(1)',
            bgcolor: '#fff',
            color: '#49a7ab',
            borderRadius: 2,
            boxShadow: 5,
            p: 1.5,
            zIndex: 9999,
            textAlign: 'center',
            minWidth: 500,
            animation: 'popout 0.2s ease',
          }}
        >
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
            Premium Functionality
          </Typography>
          <NavLink to="/accounts" style={{ textDecoration: 'none' }}>
            <Button
              variant="contained"
              sx={{
                bgcolor: '#49a7ab',
                color: '#fff',
                fontWeight: 600,
                fontSize: '.875rem',
                '&:hover': { bgcolor: '#42999d' },
              }}
            >
              Subscribe
            </Button>
          </NavLink>
          <style>
            {`
              @keyframes popout {
                0% { transform: translate(-100%, -50%) scale(0.7); opacity: 0; }
                100% { transform: translate(-100%, -50%) scale(1); opacity: 1; }
              }
            `}
          </style>
        </Box>
      )}
    </>
  );
};

export default LimitedNextBestNavigator;
